function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 31.2c.248-6.007-2-13.2 1-18.2 11.262-2.493 6.578 14.864 9 23l5-3c-1.822-3.108-2.92-5.741-3-15 0-5-2.807-7.229-7-7-3.309.18-5.146 2.434-5.138 6.3.01 5.078 1.83 8.447 5.138 7.7 1.268-.286 2.018-1.18 3-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25 24.9V30c-3 1-4 2-6 4 2 2 5 4 13 2M26 48c1.005-4.648 1.758-9.262 11-15 4.818 4.769 6.556 8.171 7 11M19 34c-.797.754-2.413 5.243-3 8l-4 6M18 41c.343 3.339 1.512 5.413 3 7M22.286 17.51c.573-.448.81-.448 1.214-.448M25 21v-4c2-.505 2 1 3.533.39M24.457 22.33c.761.274 1.252.126 1.543-.33"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  strokeWidth: 1,
  d: "M8 5.737h38v43H8z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  strokeWidth: 1,
  d: "M6 3.474h42V51H6z"
}));

var SvgTheMonaLisa = function SvgTheMonaLisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTheMonaLisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/The Mona Lisa.81f1d73d.svg";
export { ForwardRef as ReactComponent };